

// Get the dropdown trigger and the menu
const customDropdownTrigger = document.querySelector('.custom-navigation__dropdown');
const customDropdownTriggerText = document.querySelector('.custom-navigation__dropdown span');
const dropdownMenu = document.querySelector('.custom-navigation__dropdown-item');

// Toggle dropdown menu on click
customDropdownTrigger.addEventListener('click', function() {
    if (dropdownMenu.style.display === 'block') {
        customDropdownTrigger.classList.remove('active');
        dropdownMenu.style.display = 'none';
    } else {
        customDropdownTrigger.classList.add('active');
        dropdownMenu.style.display = 'block';
    }
});

// Hide dropdown if clicked outside
window.addEventListener('click', function(event) {
    if (window.innerWidth < 992) {
        if (!event.target.matches('.custom-navigation__dropdown')) {
            dropdownMenu.style.display = 'none';
        }
    }
});

// Optionally handle click on dropdown items
const dropdownItems = document.querySelectorAll('.custom-navigation__dropdown-item li');
dropdownItems.forEach(item => {
    item.addEventListener('click', function() {
        if (window.innerWidth < 992) {
            customDropdownTriggerText.textContent = this.textContent; // Update trigger text
            dropdownMenu.style.display = 'none'; // Close dropdown
            customDropdownTrigger.classList.remove('active');
        }
    });
});

// Select custom nav items active class add or remove
const navItems = document.querySelectorAll('.custom-navigation__dropdown-item a');

// Add click event listener to each nav item
navItems.forEach(item => {
    item.addEventListener('click', function() {
        // Remove the "active" class from all nav items
        navItems.forEach(nav => nav.classList.remove('active'));

        // Add the "active" class to the clicked item
        this.classList.add('active');
    });
});

// Select all links in the nav bar
const anchors = document.querySelectorAll('.custom-navigation__dropdown-item li a, a[href="#Specifications_Care"]');

// Function to smoothly scroll to the target section over a specific duration
function smoothScrollTo(target, duration) {
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    let startTime = null;

    function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
    }

    function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(animation);
}

// Loop through all selected elements
for (let i = 0; i < anchors.length; i++) {
    anchors[i].addEventListener('click', function(e) {
        e.preventDefault(); // Prevent default anchor click behavior

        // Get the target section from the href attribute
        const targetSection = document.querySelector(this.getAttribute('href'));

        // Check if the target section exists on the current page
        if (targetSection) {
            // Smooth scroll to the target section over 1000ms (1 second)
            smoothScrollTo(targetSection, 1000);
        } else {
            // If target section does not exist, redirect to the linked page
            const targetUrl = this.getAttribute('href');
            window.location.href = targetUrl;  // Redirect to the appropriate page
        }
    });
}


// Add click event listener to each nav item
const spcNavItems = document.querySelector('a[href="#Specifications_Care"]');
spcNavItems.addEventListener('click', function() {
    navItems.forEach(spcitem => {
        // Remove the "active" class from all nav items
        // spcitem.forEach(nav => nav.classList.remove('active'));
        spcitem.classList.remove('active')
        if (spcitem.getAttribute("href") == "#Specifications_Care" ) {
            // console.log(spcitem.getAttribute("href"));
            spcitem.classList.add('active');
            if (window.innerWidth < 992) {
                customDropdownTriggerText.textContent = spcitem.getAttribute("title"); // Update trigger text
            }
        }
        
        // // Add the "active" class to the clicked item
        // this.classList.add('active');
    });
});

// Handle window resize
window.addEventListener('resize', function() {
    const dropdownMenu = document.querySelector('.custom-navigation__dropdown-item');
    // If the window is resized to a width greater than 992px, ensure the dropdown is closed
    if (window.innerWidth >= 992) {
        dropdownMenu.removeAttribute('style');
        // dropdownMenu.style.display = 'none';
    } else {
    }
});
